import { css as e } from "styled-components";
const n = {
  base: () => /* @__PURE__ */ e([
    "display:inline-block;flex-shrink:0;svg{width:100%;height:100%;fill:currentColor;pointer-events:none;}"
  ])
};
export {
  n as default
};
